import { Action, createReducer, on } from '@ngrx/store';

import { setEditSearchByProductAction } from '@app/store/actions/global.actions';
import * as userHistoryActions from '@user-history/store/actions/user-history.actions';
import * as flightsResultsActions from '@flight-results/store/actions/flights-results.actions';
import * as hotelsActions from '@hotels/hotel-results/store/actions/hotels.actions';
import * as hotelDetailActions from '@hotels/hotel-detail/store/actions/hotels.actions';
import * as busResultsActions from '@buses/bus-results/store/actions/bus-results.actions';
import * as autoActions from '@autos/auto-results/store/actions/auto.actions';
import * as packagesResultActions from '@packages/packages-result/store/actions/packages-result.actions';
import * as activitiesResultsActions from '@activities/activities-results/store/actions/activities-results.actions';
import { HeaderProductType } from '@header/entities/ds-header-config';

export const initialState = null;

const featureReducer = createReducer(
  initialState,
  on(
    userHistoryActions.exchangeSearchAction,
    flightsResultsActions.searchFlightsAction,
    flightsResultsActions.clearFlightResultsAction,
    hotelsActions.searchHotelsAction,
    hotelsActions.clearHotelResultsAction,
    busResultsActions.searchBusesAction,
    busResultsActions.clearBusesResultsAction,
    autoActions.searchAutoAction,
    autoActions.clearAutoResultsAction,
    packagesResultActions.searchPackageAction,
    hotelDetailActions.fetchHotelDetailAction,
    activitiesResultsActions.cleanActivitiesResultsAction,
    () => initialState
  ),
  on(setEditSearchByProductAction, (state, { product }) => product),
);

export const editSearchReducer = (state: HeaderProductType, action: Action): HeaderProductType => {
  return featureReducer(state, action);
};
